<template>
    <div>
        <v-row class="justify-center mt-10">
            <h2>Felhasználó statisztika</h2>
        </v-row>

        <v-row>
            <v-col
                v-for="station in stations"
                :key="station.id"
                cols="12"
                sm="4"
                md="3"
            >
                <v-card :color="station.color" outlined>
                    <v-card-title class="pa-1 text-body2">
                        {{ station.name }}
                    </v-card-title>

                    <v-card-text class="pa-1">
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th class="pa-1">Név</th>
                                    <th class="pa-1">Alk. (DB)</th>
                                    <th class="pa-1">Hiba</th>
                                    <th class="pa-1">%</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="stat in filterUserWorkStatsByStation(station.id)" :key="stat.id">
                                    <td class="text-caption pa-1">{{ stat.name }}</td>
                                    <td class="text-caption pa-1">{{ stat.pieces }}</td>
                                    <td class="text-caption pa-1">{{ getUserWasteStatsByStationAndUser(station.id, stat.user_id).toFixed(1) }}%</td>
                                    <td class="text-caption pa-1">{{ (stat.pieces * 100 / getStationTotalPieces(station.id)).toFixed(1) }}%</td>
                                </tr>
                                <tr class="text-caption font-weight-bold" style="position: relative;">

                                    <td class="pa-1" style="position: relative; z-index: 1;">Előírt</td>
                                    <td class="pa-1" style="position: relative; z-index: 1;">{{ getStationTotalPieces(station.id) }} / {{ station.expected * workDays }}</td>
                                    <td class="pa-1" style="position: relative; z-index: 1;">{{ getWasteStatsByStation(station.id).toFixed(1) }}%</td>
                                    <td class="pa-1" style="position: relative; z-index: 1;">
                                        {{ getPerformancePercent(station).toFixed(1) }}%
                                    </td>   
                                    <td colspan="100%" style="padding: 0; position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 0;">
                                        <v-progress-linear
                                        :value="getPerformancePercent(station)"
                                        :color="getPerformanceColor(station)"
                                        height="100%"
                                        rounded
                                        />
                                    </td>
                                </tr>             
                            </tbody>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>

</template>
<script>
    export default {
        props: ['dates', 'workDays', 'userWorkStats', 'userWasteStats', 'stations'],

        data: () => ({}),

        methods: {
            filterUserWorkStatsByStation(stationId) {
                return this.userWorkStats.filter(stat => stat.station_id === stationId);
            },

            getUserWasteStatsByStationAndUser(stationId, userID) {
                let wasteStats = this.userWasteStats.filter(stat => (stat.station_id === stationId && stat.user_id === userID));

                if(wasteStats.length == 0) return 0
                if(wasteStats[0].in == 0) return 0
                if(wasteStats[0].in - wasteStats[0].out < 0) return 0

                return (wasteStats[0].in - wasteStats[0].out) / (wasteStats[0].in) * 100
            },

            getWasteStatsByStation(stationId) {
                let wasteStats = this.userWasteStats.filter(stat => (stat.station_id === stationId));

                if(wasteStats.length == 0) return 0
                
                let sumIn = wasteStats.reduce((sum, item) => sum + parseInt(item.in) || 0, 0)
                let sumOut = wasteStats.reduce((sum, item) => sum + parseInt(item.out) || 0, 0)

                if(sumIn == 0) return 0
                if(sumIn - sumOut < 0) return 0

                return (sumIn - sumOut) / (sumIn) * 100
            },

            getStationTotalPieces(stationId) {
                return this.filterUserWorkStatsByStation(stationId).reduce((sum, item) => sum + parseInt(item.pieces), 0)
            },

            getPerformancePercent(station) {
                const actual = this.getStationTotalPieces(station.id);
                const expected = station.expected * this.workDays;

                return expected ? (actual / expected) * 100 : 0;
            },

            getPerformanceColor(station) {
                const percent = this.getPerformancePercent(station);
                if (percent < 50) return 'red lighten-2';
                else if (percent < 80) return 'orange lighten-2';
                else return 'green lighten-2';
            },
        },
    }
</script>